import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tw-relative tw-hidden tw-aspect-video tw-h-[65px] lg:tw-flex" }
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-bg-muted tw-text-center tw-text-slate-400"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "tw-aspect-video tw-h-full tw-overflow-hidden tw-rounded-lg tw-bg-slate-100 tw-object-cover dark:tw-bg-slate-700",
  "data-testid": "video-library-item-thumbnail-error"
}
const _hoisted_5 = {
  class: "tw-absolute tw-bottom-0 tw-flex tw-w-full tw-justify-center tw-rounded-b-lg tw-bg-black/70 tw-p-1 tw-text-center tw-text-2xs tw-text-slate-100",
  "data-testid": "video-library-item-duration"
}

import { computed, ref } from 'vue';

import { VideoAsset } from '../videoLibraryService';

import TablerLoader2 from '@/studioComponents/Icons/tabler/TablerLoader2.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoLibraryItemThumbnail',
  props: {
    videoAsset: {}
  },
  setup(__props: any) {

const props = __props;



const thumbnailError = ref(false);

const onThumbnailError = () => {
  thumbnailError.value = true;
};

const videoDuration = computed(() => {
  if (props.videoAsset.duration.split(':')[0] === '00') {
    return props.videoAsset.duration.split(':').slice(1).join(':');
  }
  return props.videoAsset.duration;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (['PROGRESSING', 'SUBMITTED'].includes(_ctx.videoAsset.status))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(TablerLoader2, { class: "tw-h-4 tw-w-4 tw-animate-spin" })
        ]))
      : (!thumbnailError.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "tw-h-full tw-w-full tw-rounded-lg tw-bg-slate-100 tw-object-contain",
            "data-testid": "video-library-item-thumbnail-img",
            src: _ctx.videoAsset.urls.thumbnail,
            onError: onThumbnailError
          }, null, 40, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
    _createElementVNode("div", _hoisted_5, _toDisplayString(videoDuration.value), 1)
  ]))
}
}

})